import { resetPasswordRequestSchema } from '@up2d8/contracts';

/**
 * Ligt het aan de link of aan het gekozen wachtwoord?
 *
 * Een herstel- of uitnodigingslink draagt een token. Een ingekort token (een mailprogramma dat de
 * link afbrak, een kopie die half meekwam) of geen token keurt de server af met `400`, net als een te
 * zwak wachtwoord. Het scherm toonde bij elke `400` "Dit wachtwoord voldoet niet. Probeer een langere
 * zin.": dan probeert iemand het ene wachtwoord na het andere op een link die nooit gaat werken
 * (testrapport 28 okt., fout 19). De fout hoort bij de link: "Deze link werkt niet meer", met de weg
 * naar een nieuwe.
 */

/** Kan dit token kloppen? Dezelfde regel als de server, uit het contract: geen gok. */
export function tokenLooksValid(token: string): boolean {
  return resetPasswordRequestSchema.shape.token.safeParse(token).success;
}

/**
 * Wat een mislukte aanroep met token en wachtwoord betekent.
 *
 * - `password`: de server keurde het wachtwoord af (`400`, op het veld `password`).
 * - `link`: al de rest - verlopen, gebruikt of onbekend (`404`, `409`), of een `400` op het token.
 *
 * Een `400` zonder veldenlijst telt als wachtwoord: zo deed het scherm het altijd, en het
 * wachtwoord is het enige veld dat iemand op dit scherm zelf invult.
 */
export function linkFailure(status: number, problem: unknown): 'password' | 'link' {
  if (status !== 400) return 'link';
  const errors = (problem as { errors?: unknown } | null | undefined)?.errors;
  if (!Array.isArray(errors)) return 'password';
  const onToken = errors.some((error) => {
    const path = (error as { path?: unknown } | null)?.path;
    return typeof path === 'string' && (path === 'token' || path.startsWith('token.'));
  });
  return onToken ? 'link' : 'password';
}
